import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Page from '../common/page/Page'
import Poll from '../../models/Poll'
import PollsList from './List'
import Masthead from './Masthead'
import './Polls.less'

const meta = {
	title: 'Polls',
	description: 'Create your own poll with any question you like and easily send it to people.',
}

export default function Polls(props) {
	return (
		<Page className="polls" {...meta} masthead={<Masthead {...props} />}>
			{props.polls.length ? (
				<PollsList {...props} />
			) : (
				<p className="empty">No polls. Create one?</p>
			)}
			<div className="actions pinned">
				<FloatingActionButton
					onClick={() => browserHistory.push('/create')}
				>
					<ContentAdd />
				</FloatingActionButton>
			</div>
		</Page>
	)
}

Polls.propTypes = {
	polls: PropTypes.arrayOf(PropTypes.instanceOf(Poll)),
}



// WEBPACK FOOTER //
// ./src/components/polls/Polls.jsx